"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "StripePaymentForm", {
  enumerable: true,
  get: function get() {
    return _StripePaymentForm.default;
  }
});
var _StripePaymentForm = _interopRequireDefault(require("./StripePaymentForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }